import enviro from 'enviro';
import { BLOG_RESEARCH_AGENT_LISTING_SLUG, FREE_ACCESS_AGENT_LISTING_IDS_PROD, FREE_ACCESS_AGENT_LISTING_IDS_QA } from '../constants/Agents';
export function getIsBlogResearchAgentListing(listingSlug) {
  return listingSlug === BLOG_RESEARCH_AGENT_LISTING_SLUG;
}
export function getIsFreeAccessAgent(listingId) {
  const isQa = enviro.isQa();
  return isQa ? FREE_ACCESS_AGENT_LISTING_IDS_QA.includes(listingId) : FREE_ACCESS_AGENT_LISTING_IDS_PROD.includes(listingId);
}